const FX_EVENT_NAME = 'FxStatusUpdate'

/**
 * @param {object} payload - SignalR event payload
 * @returns {boolean}
 */
export function isValidFxStatusPayload(payload) {
  return (
    payload &&
    typeof payload === 'object' &&
    payload.updatedScope === FX_EVENT_NAME &&
    payload.data &&
    typeof payload.data.PaymentId === 'string' &&
    payload.data.PaymentId.length > 0
  )
}

/**
 * @param {import('@microsoft/signalr').HubConnection} connection
 * @param {function} callback - receives validated PaymentId string
 */
function getTransportName(conn) {
  try {
    const transport = conn.connection && conn.connection.transport
    if (!transport) return 'Unknown'
    const name = (transport.constructor && transport.constructor.name) || ''
    if (name.indexOf('WebSocket') !== -1) return 'WebSockets'
    if (name.indexOf('ServerSentEvents') !== -1) return 'SSE'
    if (name.indexOf('LongPolling') !== -1) return 'LongPolling'
    return name || 'Unknown'
  } catch (e) {
    return 'Unknown'
  }
}

export function subscribeFxStatusUpdates(connection, callback) {
  if (!connection) return

  connection.on(FX_EVENT_NAME, payload => {
    const transport = getTransportName(connection)
    console.log(
      'FX SignalR message received via [' + transport + ']:',
      JSON.stringify(payload)
    )
    if (isValidFxStatusPayload(payload)) {
      callback(payload.data.PaymentId)
    } else {
      console.log('FX SignalR message invalid payload, skipped.')
    }
  })
}

/**
 * @param {import('@microsoft/signalr').HubConnection} connection
 */
export function unsubscribeFxStatusUpdates(connection) {
  if (!connection) return
  connection.off(FX_EVENT_NAME)
}
